export default __webpack_public_path__ + "static/media/GT.e57ae23a.svg";